module.exports = __webpack_public_path__ + "static/media/profile_drop_down.0f943cf1.svg";